<template>
    <div class="content-wrapper">
        <div class="row">
            <div class="col-sm-12 col-md-6">
                <app-breadcrumb :page-title="$t('supportrequest')" :icon="'user-check'"/>
            </div>
        </div>

        <div class="row">
            <supportrequest-datatable></supportrequest-datatable>
        </div>
    </div>
</template>

<script>

    import datatable from "../Invoice/Datatable";

    export default {
        name: "User",
        components: {
            datatable
        },
    } 
</script>
